/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CustomersRequestBuilderNavigationMetadata, type CustomersRequestBuilder } from './customers/index.js';
// @ts-ignore
import { TearsheetsRequestBuilderNavigationMetadata, TearsheetsRequestBuilderRequestsMetadata, type TearsheetsRequestBuilder } from './tearsheets/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v1/organizations/{organizationId}
 */
export interface WithOrganizationItemRequestBuilder extends BaseRequestBuilder<WithOrganizationItemRequestBuilder> {
    /**
     * The customers property
     */
    get customers(): CustomersRequestBuilder;
    /**
     * The tearsheets property
     */
    get tearsheets(): TearsheetsRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const WithOrganizationItemRequestBuilderUriTemplate = "{+baseurl}/api/v1/organizations/{organizationId}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithOrganizationItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithOrganizationItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    customers: {
        navigationMetadata: CustomersRequestBuilderNavigationMetadata,
    },
    tearsheets: {
        requestsMetadata: TearsheetsRequestBuilderRequestsMetadata,
        navigationMetadata: TearsheetsRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
